import { render, staticRenderFns } from "./accordions.vue?vue&type=template&id=a81f4d3c"
import script from "./accordions.vue?vue&type=script&lang=js"
export * from "./accordions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports